import request from '@/utils/request'

// 登录
export function login(params) {
  return request({
    url: "/coyote/front/backstage/Login",
    method: "POST",
    data: params
  });
}

// 首次登录 修改密码
export function resetPass(params) {
  return request({
    url: "/coyote/front/backstage/updatePassword",
    method: "POST",
    data: params
  });
}
// 用户 修改密码2 userUpdatePassword
export function userUpdatePassword(data) {
  return request({
    url: '/coyote/front/backstage/userUpdatePassword',
    method: 'post',
    data,
  })
}

// 退出
export function logout() {
  return request({
    url: '/coyote/front/backstage/logout',
    method: 'post',
  })
}
